export default __webpack_public_path__ + "static/simple-perfil-1fc87b131f0ff90bdcdf9bac6008b3c8.png";